/* ═══════════════════════════════════════════════════════
   FT Card AJAX Add-to-Cart — Global Handler
   
   Loaded once per page via <script src=""> in theme.liquid.
   
   Because it's a real .js asset file (not inline <script>
   inside a liquid snippet), it executes correctly even for
   product cards that get injected into the DOM after page
   load — e.g. inside the product-recommendations section
   which uses morphSection() to hydrate its cards.
   
   Event delegation on `document` catches every click on
   [data-ft-atc-card] buttons regardless of when the button
   was added to the page.
   ═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (window.__ftCardAtcInit) return;
  window.__ftCardAtcInit = true;

  /* ---------- Constants ---------- */
  var LOADING_HTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="animation: ftSpin 0.8s linear infinite;width:18px;height:18px;"><circle cx="12" cy="12" r="10" stroke-dasharray="30 60" stroke-linecap="round" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  var SUCCESS_HTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px;"><polyline points="20 6 9 17 4 12"/></svg>';

  var ROUTE_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root
    : '/';

  /* ---------- Inject spinner keyframes once ---------- */
  if (!document.getElementById('ft-card-spin-keyframes')) {
    var styleTag = document.createElement('style');
    styleTag.id = 'ft-card-spin-keyframes';
    styleTag.textContent = '@keyframes ftSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }';
    document.head.appendChild(styleTag);
  }

  /* ---------- Detect cart-related section IDs in DOM ---------- */
  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll(
      'cart-drawer, cart-drawer-component, ' +
      '#cart-drawer, #CartDrawer, [data-cart-drawer], ' +
      'cart-icon, #cart-icon-bubble, .cart-bubble'
    ).forEach(function (el) {
      var section = el.closest('.shopify-section[id^="shopify-section-"]');
      if (section) {
        var id = section.id.replace('shopify-section-', '');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      }
    });
    return ids;
  }

  /* ---------- Update Horizon cart bubble/count in header ---------- */
  function updateCartCount(itemCount) {
    /* 1. Write the number into every count text element */
    document.querySelectorAll(
      '[data-testid="cart-bubble"], .cart-bubble__text-count, [ref="cartBubbleCount"]'
    ).forEach(function (el) {
      el.textContent = itemCount;
    });

    /* 2. Remove "hidden" class from inner count span */
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      if (itemCount > 0) {
        el.classList.remove('hidden', 'visually-hidden');
        el.removeAttribute('hidden');
      } else {
        el.classList.add('hidden');
      }
    });

    /* 3. Remove "visually-hidden" from bubble wrapper */
    document.querySelectorAll('.cart-bubble, [ref="cartBubble"]').forEach(function (bubble) {
      if (itemCount > 0) {
        bubble.classList.remove('visually-hidden', 'hidden');
        bubble.removeAttribute('hidden');
        bubble.style.display = '';
      } else {
        bubble.classList.add('visually-hidden');
      }
    });

    /* 4. Toggle has-cart state on cart-icon web component */
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach(function (icon) {
      if (itemCount > 0) {
        icon.classList.add('header-actions__cart-icon--has-cart');
      } else {
        icon.classList.remove('header-actions__cart-icon--has-cart');
      }
    });

    /* 5. Update screen reader live region */
    var liveRegion = document.querySelector(
      '[data-testid="cart-count-live-region"], [ref="liveRegion"]'
    );
    if (liveRegion) {
      liveRegion.textContent = 'Total items in cart: ' + itemCount;
    }

    /* 6. Generic fallback selectors */
    ['.cart-count', '[data-cart-count]', '.cart-item-count'].forEach(function (selector) {
      try {
        document.querySelectorAll(selector).forEach(function (el) {
          if (el.children.length === 0) el.textContent = itemCount;
        });
      } catch (e) {}
    });
  }

  /* ---------- Replace section HTML in DOM ---------- */
  function replaceSectionHTML(sectionId, newHTML) {
    var container = document.getElementById('shopify-section-' + sectionId);
    if (!container || !newHTML) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString(newHTML, 'text/html');

    var newSection = doc.getElementById('shopify-section-' + sectionId);
    if (newSection) {
      container.innerHTML = newSection.innerHTML;
    } else {
      container.innerHTML = newHTML;
    }
  }

  /* ---------- Open the cart drawer (multi-strategy) ---------- */
  function openCartDrawer() {
    /* Strategy 1: Click Horizon's actual drawer trigger button */
    var trigger = document.querySelector(
      '[data-testid="cart-drawer-trigger"], ' +
      'button[aria-controls="cart-drawer"], ' +
      'button[aria-controls="CartDrawer"]'
    );
    if (trigger) {
      trigger.click();
      return true;
    }

    /* Strategy 2: Call methods on the drawer element directly */
    var drawer = document.querySelector(
      'cart-drawer, cart-drawer-component, #cart-drawer, #CartDrawer, [data-cart-drawer]'
    );
    if (drawer) {
      if (typeof drawer.open === 'function')      { drawer.open();      return true; }
      if (typeof drawer.show === 'function')      { drawer.show();      return true; }
      if (typeof drawer.showModal === 'function') { drawer.showModal(); return true; }

      drawer.removeAttribute('hidden');
      drawer.setAttribute('open', '');
      drawer.classList.add('is-open', 'active', 'open');
      return true;
    }

    /* Strategy 3: Dispatch events */
    document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open',        { bubbles: true }));
    document.dispatchEvent(new CustomEvent('drawerOpen',       { bubbles: true, detail: 'cart' }));

    return false;
  }

  /* ---------- Reset button back to original state ---------- */
  function resetButton(btn, originalHTML) {
    btn.classList.remove('is-loading', 'is-success');
    btn.innerHTML = originalHTML;
    btn.disabled = false;
  }

  /* ---------- Main click handler (event delegation on document) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ft-atc-card]');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId || isNaN(variantId)) {
      console.warn('[FT Card ATC] No valid variant ID on button', btn);
      return;
    }

    var originalHTML = btn.innerHTML;

    btn.classList.add('is-loading');
    btn.disabled = true;
    btn.innerHTML = LOADING_HTML;

    var sectionIds = getCartSectionIds();

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    /* Step 1: Add item to cart */
    fetch(ROUTE_ROOT + 'cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (errData) {
            throw new Error(errData.description || errData.message || 'Failed to add item to cart');
          });
        }
        return res.json();
      })
      .then(function (addResponse) {
        /* Update returned sections in DOM */
        if (addResponse.sections) {
          Object.keys(addResponse.sections).forEach(function (sectionId) {
            replaceSectionHTML(sectionId, addResponse.sections[sectionId]);
          });
        }

        /* Step 2: Get updated cart state */
        return fetch(ROUTE_ROOT + 'cart.js', {
          headers: { 'Accept': 'application/json' }
        }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.innerHTML = SUCCESS_HTML;

        updateCartCount(cart.item_count);

        /* Dispatch cart events for any other listeners */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { cart: cart, source: 'ft-card-atc' }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: cart
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: cart
        }));

        /* Open cart drawer (small delay to let DOM settle) */
        setTimeout(function () {
          openCartDrawer();
        }, 150);

        /* Reset button after 2 seconds */
        setTimeout(function () {
          resetButton(btn, originalHTML);
        }, 2000);
      })
      .catch(function (err) {
        console.error('[FT Card ATC]', err);
        resetButton(btn, originalHTML);
        btn.style.borderColor = '#e74c3c';
        setTimeout(function () {
          btn.style.borderColor = '';
        }, 1500);
      });
  });

  console.log('[FT Card ATC] Global handler initialized');
})();